/* Stylesheet */

.content {
  .title {
    color: var(--ion-color-primary);
    line-height: 2;
    font-weight: bolder;
  }

  .subtitle {
    margin: 0px 0px 16px 0px;
  }

  .paragraph {
    margin: 52px 0px 52px 0px;
    color: var(--ion-color-text-primary);
    line-height: 2;
  }
}
